import styled from "styled-components";

export const SearchableDropdownContainer = styled.div`
    &.ltr{
        direction: ltr !important;
    }
    &.is-invalid{
        & div[class*="__control"]{
            border-color: var(--bs-form-invalid-border-color);
            padding-right: calc(1.5em + .75rem);
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='0.6' fill='%23dc3545' stroke='none'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right calc(.375em + .1875rem) center;
            background-size: calc(.75em + .375rem) calc(.75em + .375rem);
        }
    }
    &.input-light{
        --bs-body-bg: #e1e1e1;
        --bs-border-color: #e1e1e1;
        --bs-body-color: #333;
        --bs-body-focus-color: #444;
        --bs-body-focus-bg: #fff;
        &:disabled{
            background-color: #c5c5c5;
            border-color: #c5c5c5;
            color: #5d5d5d;
        }
    }
`